import template from './hotel-room-component.html';
import hotelRoomDetailsTemplate from './hotel-room-details/hotel-room-details.html';
import './hotel-room-details/hotel-room-details.scss';
import HotelRoomDetailsPopupController from './hotel-room-details/hotel-room-details-popup-controller';
import {outOfPolicyStatus} from '../../common/enum/out-of-policy-status-enum';
import {outOfPolicyStatusStyle} from '../../common/enum/out-of-policy-status-style';

export default function HotelRoom() {
        return {
            restrict: 'A',
            template,
            scope: {
                room: '=room',
                onBook: '&onBook',
                hotel: '=hotel',
                searchId: '=',
            },
            controller: HotelRoomController,
            controllerAs: 'hotelRoomCtrl',
        link: function($scope, $elem, $attrs, hotelRoomCtrl) {
            hotelRoomCtrl.$onInit();
        },
    };
}

export function HotelRoomController(
    $scope,
    $uibModal,
    $stateParams,
    userService,
    basketService,
    l10nService,
    hotelRoomDetailsService,
    supplierService,
    REFUNDABLE_TYPES
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        showMoreDetailsPopup,
        showNonRefundableLabel,
        showMoreDetailsLink,
		showCancellationConditions,
        getOutOfPolicyStatusStyle,
        REFUNDABLE_TYPES,
    });

    function $onInit() {
        initializeScope($scope);
    }

    function initializeScope(scope) {
        scope.regionalSettings = userService.getRegionalSettings();
        scope.room.Rate = scope.room.Rate || scope.room.RateCodeDisplayString;
        scope.cantBeAddedToBasket = function(room) {
            return scope.inBasket(room) || room.OutOfPolicyStatus === outOfPolicyStatus.OutOfPolicyBookingProhibited || !scope.hotel.CanBeBooked || scope.hotel.areAddToBasketButtonsDisabled;
        };
        scope.inBasket = function(room) {
            return basketService.inBasket('room', room);
        };
        scope.bookAttrTitle = function(hotel) {
            return (!hotel.CanBeBooked)
                ? l10nService.localize('Please contact Key Travel to book this option as it is close to '
                    + 'the departure time')
                : '';
        };
        scope.range = function(min, max) {
            return _.range(min, max + 1);
        };
        scope.l10n = l10nService;
    }

    function showNonRefundableLabel(room) {
        return !supplierService.isAmadeusId(room.Supplier) && room.Refundable === REFUNDABLE_TYPES.NON_REFUNDABLE;
    }

    function showMoreDetailsLink(room) {
        return (supplierService.isAmadeusId(room.Supplier) && !room.CancellationConditions) || (room.Refundable && supplierService.isHotelBedsId(room.Supplier) && !room.CancellationConditions);
    }

    function showCancellationConditions(room) {
        return room.Refundable !== REFUNDABLE_TYPES.NON_REFUNDABLE
            && !!room.CancellationConditions
            && (!supplierService.isHotelBedsId(room.Supplier) || !!room.CancellationConditions);
    }

    function showMoreDetailsPopup(room, hotel) {
        const {Id: roomId} = room;
        const {Id: hotelId, searchId = $stateParams.searchId} = hotel;

        $uibModal.open({
            template: hotelRoomDetailsTemplate,
            size: 'lg',
            controller: HotelRoomDetailsPopupController,
            controllerAs: 'hotelRoomDetailsPopupCtrl',
            resolve: {
                roomDetails: function() {
                    return hotelRoomDetailsService.getRoomDetails(roomId, hotelId, searchId);
                },
            },
        });
    }

    function getOutOfPolicyStatusStyle(status) {
            return outOfPolicyStatusStyle(status);

    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotel-room/hotel-room-component.js